export default __webpack_public_path__ + "static/media/referrals-selected.4ee40535.svg";